import type { CareplanActivity, CareplanActivityMeta } from '@healthblocks-io/core'
import type {
  DocumentFile,
  SignableDocument,
  SignableDocumentActivity,
  SignableDocumentDetailField,
} from '../types/documents.types'

function isFieldValid(field: SignableDocumentDetailField, activity: SignableDocumentActivity) {
  if (field.hidden || field.readonly) {
    const fieldInput = activity.inputs.find((input) => input.fieldId === field.id)
    return !!fieldInput?.value
  }

  return true
}

// Documents are valid if they have to fields that are hidden / readonly without a placeholder
export function isDocumentValid(document: SignableDocument) {
  return document.activities.every((activity) => {
    if (activity.definition.type !== 'Form') {
      return true
    }
    return activity.definition.fields.every((field) => {
      return isFieldValid(field, activity)
    })
  })
}

export function isSignableDocument(file: DocumentFile): file is SignableDocument {
  return (
    typeof (file as SignableDocument).versionId === 'number' && Array.isArray((file as SignableDocument).activities)
  )
}

export function isMessageDocument(file: DocumentFile): file is CareplanActivity<'Message', CareplanActivityMeta> {
  return !isSignableDocument(file) && file.type === 'Message'
}
